import React from "react";
import { Box, Card, CardContent, Container } from "@mui/material";

import { useParams } from 'react-router-dom';

//project imports
// import Main from "layout/Main";
import UserSendForm from "./UserForms/UserDeleteForm";

const ProfileDeleteApp = () => {
  const { appname } = useParams();
  console.log("Delete AppName: ", appname);



  return (
    // <Main>
      <Container>
        <Box pt={20} sx={{ flexGrow: 1 }} pb={20}>
          <Card sx={{shadow: 2}}> 
            <CardContent>
                <UserSendForm appname={appname}/>
            </CardContent>
          </Card>
        </Box>
      </Container>
    // </Main>
  );
};

export default ProfileDeleteApp;

// ?appName=AppName
